/**
 * Created by luka on 03.03.2021.
 */
import i18n from 'i18next';

export function formatMoney(sum, currency, digits) {
    const lang = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
    const formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency.toUpperCase(),
        minimumFractionDigits: digits,
    });

    return formatter.format(sum);
}


// WEBPACK FOOTER //
// ./src/utils/MoneyHelper.js